import { useRecordContext } from 'react-admin';

export const TruncatedTextField = ({
  source,
  maxLength = 50,
}: {
  source: string;
  maxLength?: number;
}) => {
  const record = useRecordContext();
  if (!record || !source) return null;

  const value = (record as any)[source] as string;
  if (!value) return null;

  const truncated = value.length > maxLength ? `${value.substring(0, maxLength)}...` : value;
  return <span title={value}>{truncated}</span>;
};
